export const findPaddingHorizontal = (width) => {
  if (width >= 1024 && width <= 1240) return 25
  if (width >= 1241 && width <= 1535) return 72
  if (width >= 1536 && width <= 1790) return 120
  if (width >= 1791 && width <= 1915) return 180
  if (width >= 1916 && width <= 2050) return 260
  if (width >= 2051 && width <= 2200) return 320
  return 400
}
